import styled from 'styled-components';

export const Example = styled.div`
	border: 2px solid black;
	border-radius: 3px;
	display: inline-block;
	padding: 8px;
`;
